import React, { useState } from "react";
import s from "./UploadModal.module.css";

import { useTranslation } from "react-i18next";
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";
import Swal from "sweetalert2";

import Grid from "@mui/material/Grid"
import Modal from "@mui/material/Modal"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"

import CloseIcon from "@mui/icons-material/Close";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import useTranslationException from "../../../../../helpers/exceptions";
import { getOrganizationId } from "../../../../../utils/session.utils";

function simulateAsync() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}

const defaultFile = {
  file: "",
  raffleNum: 0,
};

// ========================= | UPLOAD MODAL | ==================================

const UploadModal = ({ open, setOpen, getFiles, setConciliationModal }) => {
  const [file, setFile] = useState(null);
  const [data, setData] = useState(defaultFile);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const handleSubmitFile = (e) => {
    setLoading(true);

    let name = e[0]?.name;
    let raffle = name.substring(name.length - 4);
    let regex = /^[A-Z]{3}VTA\.\d{4}$/;

    if (regex.test(name)) {
      setFile(e[0]);
      setData({
        file: e[0].name,
        raffleNum: raffle,
      });
    } else {
      let formato = "XXXVTA.XXXX";
      Swal.fire(t("wrongFile"), `${t("fileFormat")} ${formato}`, "warning");
    }

    simulateAsync().then(() => setLoading(false));
  };

  const processFile = () => {
    setLoading(true);
    const f = new FormData();

    f.append("file", file, file.name);
    f.append("organizationId", getOrganizationId())

    masiveDistributionServices
      .postVtaFile(f)
      .then((response) => {
        const {
          supplierLotteryConcliliated,  // Boolean
          lotteryAgencyConcliliated,    // Boolean
          supplier_lottery,             // SupplierLottery: { sended: {}, returned: {}}
          lottery_agency,               // LotteryAgency[]
        } = response.conciliationData
        // NOTE: This is for disable the conciliation functionality
        // const conciliationData = {
        //   supplierLottery: supplierLotteryConcliliated ? undefined : supplier_lottery,
        //   lotteryAgency: lotteryAgencyConcliliated ? undefined : lottery_agency
        // }
        //
        // if (!supplierLotteryConcliliated || !lotteryAgencyConcliliated) {
        //   setConciliationModal({ conciliationData, open: true })
        // }
      })
      .then(() => getFiles())
      .then(() => {
        setOpen(false);
        setFile(null);
      })
      .then(() => {
        Swal.fire(t("processDone"), t("fileProcessed"), "success");
        setLoading(false);
        setData(defaultFile);
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setFile(null);
        setLoading(false);
        setData({
          file: "",
          raffleNum: 0,
        });
        setOpen(false);
      });
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        setData({
          file: "",
          raffleNum: 0,
        });
        setFile(null);
      }}
    >
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("salvta")}</p>
              <span>{t("uploadFile")}</span>
            </div>
            <CloseIcon
              onClick={() => {
                setOpen(false);
                setData({
                  file: "",
                  raffleNum: 0,
                });
                setFile(null);
              }}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <Grid container item xs={12} className={s.filters}>
            <label
              htmlFor="inputTelekinoFile"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                container
                item
                xs={10}
                className={s.uploadContainer}
                sx={{
                  "&:hover": {
                    backgroundColor: "secondary.light",
                    cursor: "pointer",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size="4rem" />
                ) : data.file === "" ? (
                  <>
                    <UploadFileRoundedIcon
                      sx={{ fontSize: "3.5rem", color: "primary.dark" }}
                      className={s.uploadIcon}
                    />
                    <p className={s.textUpload}>{t("uploadFile")}</p>
                  </>
                ) : (
                  <Grid container item xs={12} className={s.itemsFile}>
                    <p>{`${t("name")}: ${data.file}`}</p>
                    <p>{`${t("drawNumber")}: ${data.raffleNum}`}</p>
                  </Grid>
                )}
              </Grid>
            </label>
            <Grid item xs={12} className={s.button}>
              <Button
                size="small"
                variant="contained"
                onClick={processFile}
                disabled={data.file === "" || loading}
              >
                {t("process")}
              </Button>
            </Grid>
          </Grid>
          <input
            type="file"
            id="inputTelekinoFile"
            style={{ display: "none" }}
            onChange={(e) => handleSubmitFile(e.target.files)}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default UploadModal;
